import {generateTokens} from './create-token';
import {optionalServiceProviderMap, serviceProviderMap, valueProviderMap} from './provider-maps';

export const serviceProviderTokens = generateTokens(serviceProviderMap);
export const valueProviderTokens = generateTokens(valueProviderMap);
export const optionalServiceProviderTokens = generateTokens(optionalServiceProviderMap);

const tokenMap = {
  services: serviceProviderTokens,
  values: valueProviderTokens,
  optionalServices: optionalServiceProviderTokens,
} as const;

export default tokenMap;
